import { Predicate } from '../../types/Predicate';

/**
 * Return the complement predicate to the given predicate function.
 */
export function not<T>(predicate: Predicate<T>): Predicate<T> {
    return (value: T) => !predicate(value);
}
